<template>
  <div
    class="statisticsRows-ligne"
    :class="{'is-radius-large' : !isTotal}">
    <div
      v-if="!isTotal"
      class="is-radius-top-left-large is-radius-top-right-large"></div>
    <div class="columns is-gapless">
      <div class="columns column is-2 is-vcentered is-border-right">
        <div class="column is-paddingless-right is-padding-top is-padding-bottom is-padding-left-small">
          <strong
            v-if="isTotal"
            class="is-uppercase">Synthèse</strong>
          <strong v-else-if="entity.name">{{ entity.name }}</strong>
        </div>
      </div>
      <div class="columns column is-2 is-border-right is-vcentered">
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{ totalR0.length }}
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{ totalR1.length }}
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{ totalR2.length }}
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{ totalR3.length }}
        </div>
      </div>
      <div class="columns column is-2 is-border-right is-vcentered">
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{ successfulR0.length }}
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{ successfulR1.length }}
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{ successfulR2.length }}
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          {{ successfulR3.length }}
        </div>
      </div>
      <div class="columns column is-1 is-border-right is-vcentered">
        <div class="column is-paddingless-right is-paddingless-left has-text-centered">
          {{ canceledRdv.length }}
        </div>
      </div>
      <div class="columns column is-one-fifth is-border-right is-vcentered">
        <div class="column is-4 is-paddingless-right is-padding-left-small">
          <stat-value
            v-if="R0toR1"
            :value="R0toR1"
            :percentage="true"
            :total="isTotal"
            :class="{'has-text-weight-bold': isTotal}"></stat-value>
          <span v-else>--</span>
        </div>
        <div class="column is-4 is-paddingless-right is-padding-left-small">
          <stat-value
            v-if="R1toR2"
            :value="R1toR2"
            :percentage="true"
            :total="isTotal"
            :class="{'has-text-weight-bold': isTotal}"></stat-value>
          <span v-else>--</span>
        </div>
        <div class="column is-4 is-paddingless-right is-padding-left-small">
          <stat-value
            v-if="R2toR3"
            :value="R2toR3"
            :percentage="true"
            :total="isTotal"
            :class="{'has-text-weight-bold': isTotal}"></stat-value>
          <span v-else>--</span>
        </div>
      </div>
      <div class="columns column is-2 is-vcentered">
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          <span>{{ futureR0.length }}</span>
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          <span>{{ futureR1.length }}</span>
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          <span>{{ futureR2.length }}</span>
        </div>
        <div class="column is-3 is-paddingless-right is-padding-left-small">
          <span>{{ futureR3.length }}</span>
        </div>
      </div>
      <div class="lastColumn column is-narrow has-text-centered actions is-padding-right-xsmall is-padding-left-xsmall is-padding-top-small is-padding-bottom-small">
        <button
          v-if="!isTotal && canBeRemove"
          @click="remove"
          class="button is-circle is-small">
          <i class="fal fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'StatsRdvsRow',
  components: {
    StatValue: () => import('@/components/statistics/StatValue')
  },
  props: {
    entity: {
      type: [Object, Array],
      required: true
    },
    isTotal: {
      type: Boolean,
      default: false
    },
    canBeRemove: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      rdvs: []
    }
  },
  computed: {
    pastRdvs () {
      const now = moment.utc()
      return this.rdvs.filter(x => x.date.isBefore(now))
    },
    futureRdvs () {
      const now = moment.utc()
      return this.rdvs.filter(x => x.date.isAfter(now))
    },
    totalR0 () {
      return this.pastRdvs.filter(rdv => rdv.rdv_type === 'R0')
    },
    totalR1 () {
      return this.pastRdvs.filter(rdv => rdv.rdv_type === 'R1')
    },
    totalR2 () {
      return this.pastRdvs.filter(rdv => rdv.rdv_type === 'R2')
    },
    totalR3 () {
      return this.pastRdvs.filter(rdv => rdv.rdv_type === 'R3')
    },
    successfulRdv () {
      return this.pastRdvs.filter(rdv => rdv.status === 'successful')
    },
    deferredRdv () {
      return this.pastRdvs.filter(rdv => rdv.status === 'deferred')
    },
    canceledRdv () {
      return this.pastRdvs.filter(rdv => rdv.status === 'canceled')
    },
    successfulR0 () {
      return this.successfulRdv.filter(rdv => rdv.rdv_type === 'R0')
    },
    successfulR1 () {
      return this.successfulRdv.filter(rdv => rdv.rdv_type === 'R1')
    },
    successfulR2 () {
      return this.successfulRdv.filter(rdv => rdv.rdv_type === 'R2')
    },
    successfulR3 () {
      return this.successfulRdv.filter(rdv => rdv.rdv_type === 'R3')
    },
    futureR0 () {
      return this.futureRdvs.filter(rdv => rdv.rdv_type === 'R0')
    },
    futureR1 () {
      return this.futureRdvs.filter(rdv => rdv.rdv_type === 'R1')
    },
    futureR2 () {
      return this.futureRdvs.filter(rdv => rdv.rdv_type === 'R2')
    },
    futureR3 () {
      return this.futureRdvs.filter(rdv => rdv.rdv_type === 'R3')
    },
    R0toR1 () {
      if (this.totalR1.length && this.totalR0.length) {
        return (this.totalR1.length / this.totalR0.length) * 100
      }
      return 0
    },
    R1toR2 () {
      if (this.totalR2.length && this.totalR1.length) {
        return (this.totalR2.length / this.totalR1.length) * 100
      }
      return 0
    },
    R2toR3 () {
      if (this.totalR3.length && this.totalR2.length) {
        return (this.totalR3.length / this.totalR2.length) * 100
      }
      return 0
    },
    entityColor () {
      return this.entity._color
    },
    sellers () {
      if ('_sellers' in this.entity) {
        return Object.values(this.entity._sellers)
      } else {
        return []
      }
    },
    sellersName () {
      return this.sellers.map(x => {
        return x.first_name + ' ' + x.last_name
      }).join(', ')
    }
  },
  watch: {
    entity () {
      this.initRdvs()
    }
  },
  created () {
    this.initRdvs()
  },
  methods: {
    initRdvs () {
      let rdvArray = []
      if (this.isTotal) {
        rdvArray = [ ...this.entity ]
      } else {
        if (this.entity && this.entity.items && this.entity.items.length) {
          rdvArray = [ ...this.entity.items ]
        }
      }
      this.rdvs = rdvArray.map((x) => {
        x.date = moment(x.date)
        return x
      })
    },
    remove () {
      this.$emit('remove', this.entity)
    }
  }
}
</script>

<style scoped>
  .lastColumn {
    flex: none;
    width: 47px;
  }
</style>
